export function getHomeRoute() {
    return '/'
}

export function getGameRoute() {
    return '/game';
}
